import { Assert } from "../../Assert";
import { ArrayHelper } from "../../Helpers/ArrayHelper";
import { StringHelper } from "../../Helpers/StringHelper";
import { ITypeInfoMetadata } from "./SeriouslyRAD.Framework/Reflection/ITypeInfoMetadata";

function entityAttributeProperty<T extends ITypeInfoMetadata = ITypeInfoMetadata>(typeInfoMetadata: T, attributeTypeId: string, propertyName: string): string
{
    const
        attribute =
            ArrayHelper.firstOrDefault(
                (typeInfoMetadata.attributes ?? [])
                    .filter(
                        item =>
                            item.$type === attributeTypeId
                    )
            ),
        value = attribute ? attribute[propertyName] : undefined;

    Assert.isString(value, propertyName);

    return value;
}

export function entityId<T extends ITypeInfoMetadata = ITypeInfoMetadata>(typeInfoMetadata: T): string
{
    const
        entityId = entityAttributeProperty(typeInfoMetadata, "SeriouslyRAD.Framework.ClientAwareIdAttribute, SeriouslyRAD.Framework", "id");

    return entityId.replaceAll(/\{|\}/g, StringHelper.empty);
}

export function entityName<T extends ITypeInfoMetadata = ITypeInfoMetadata>(typeInfoMetadata: T): string
{
    return entityAttributeProperty(typeInfoMetadata, "SeriouslyRAD.Framework.ClientAwareNameAttribute, SeriouslyRAD.Framework", "name");
}

export function entitySetName<T extends ITypeInfoMetadata = ITypeInfoMetadata>(typeInfoMetadata: T): string
{
    return entityAttributeProperty(typeInfoMetadata, "SeriouslyRAD.Framework.ClientAwareNameAttribute, SeriouslyRAD.Framework", "namePlural");
}

export function nameof<T extends ITypeInfoMetadata = ITypeInfoMetadata>(_: T): string
export function nameof<T extends ITypeInfoMetadata = ITypeInfoMetadata>(_: T, propertyName: keyof T["properties"]): string
export function nameof<T extends ITypeInfoMetadata = ITypeInfoMetadata>(_: T, propertyName?: keyof T["properties"]): string
{
    if (propertyName === undefined)
        return _.name;

    return propertyName as string;
}
